import { render } from "./PlansPricing.vue?vue&type=template&id=3c6a237f&scoped=true"
import script from "./PlansPricing.vue?vue&type=script&lang=js"
export * from "./PlansPricing.vue?vue&type=script&lang=js"

import "./PlansPricing.vue?vue&type=style&index=0&id=3c6a237f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6a237f"]])

export default __exports__